import { styled } from '@styles/theme'

import { SmallStyles } from './styles'

const Small = styled('small', SmallStyles.base)

export { Small }
